import { FormControl, styled } from '@mui/material';

export const CustomFormControl = styled(FormControl)(() => ({
  '& .Mui-readOnly': {
    paddingLeft: '0 !important',
  },
}));
